// Toolbar extention for BIMSearch viewer
// includes:
//      Show all button - make all elements in view visable (Cancell any isolation)/

export function ToolbarExtension(viewer, options) {
    window.Autodesk.Viewing.Extension.call(this, viewer, options);
}

ToolbarExtension.prototype = Object.create(window.Autodesk.Viewing.Extension.prototype);
ToolbarExtension.prototype.constructor = ToolbarExtension;

ToolbarExtension.prototype.load = function () {

    if (this.viewer.toolbar) {
        this.createUI();
    } else {
        this.onToolbarCreatedBinded = this.onToolbarCreated.bind(this);
        this.viewer.addEventListener(window.Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreatedBinded);
    }

    return true;
};

ToolbarExtension.prototype.onToolbarCreated = function () {

    this.viewer.removeEventListener(window.Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreatedBinded);
    this.onToolbarCreatedBinded = null;
    this.createUI();

};


ToolbarExtension.prototype.createUI = function () {

    let viewer = this.viewer;

    let showAllButton = new window.Autodesk.Viewing.UI.Button('showall-button');
    showAllButton.onClick = function (event) {
        viewer.isolate([]);
    }

    showAllButton.addClass('showall-button');
    showAllButton.setToolTip('Show all objects');

    this.subToolbar = new window.Autodesk.Viewing.UI.ControlGroup('custom-tools');
    this.subToolbar.addControl(showAllButton);

    viewer.toolbar.addControl(this.subToolbar, {index : 0});
};


ToolbarExtension.prototype.unload = function () {

    this.viewer.toolbar.removeControl(this.subToolbar);
    return true;

};

window.Autodesk.Viewing.theExtensionManager.registerExtension('ToolbarExtension', ToolbarExtension);

